import { ACTION_NOTIFICATIONS_CREATE } from '@/app/module/notifications/definitions'
import { NotificationsData } from '@/app/module/notifications/types'

export const createNotification = (data: NotificationsData) => ({
  type: ACTION_NOTIFICATIONS_CREATE,
  value: data,
})
